<template>
  <div class="settings-navigation">
    <div
      @click="skip(item.routerPath)"
      :class="[
        'navigation',
        { 'navigation-active': index === navigationIndex },
      ]"
      v-for="(item, index) in navigationList"
      :key="index"
    >
      <img
        :src="navigationIndex === index ? item.imgurlActive : item.imgurl"
        alt="图片"
      />
      <div>{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navigationIndex: 0,
      navigationList: [
        {
          name: "Profile",
          imgurl: require("@/assets/pcImg/setting/profile.png"),
          imgurlActive: require("@/assets/pcImg/setting/profile-active.png"),
          routerPath: "/settingsProfile",
        },
        {
          name: "Email",
          imgurl: require("@/assets/pcImg/setting/email.png"),
          imgurlActive: require("@/assets/pcImg/setting/email-active.png"),
          routerPath: "/settingsEmail",
        },
        {
          name: "Password",
          imgurl: require("@/assets/pcImg/setting/key.png"),
          imgurlActive: require("@/assets/pcImg/setting/key-active.png"),
          routerPath: "/settingsPassword",
        },
      ],
    };
  },
  methods: {
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
  },
  created() {
    console.log('this.$router.push',this.$router.path)
    if (this.$route.path === "/settingsProfile") {
      this.navigationIndex = 0;
    } else if (this.$route.path === "/settingsEmail") {
      this.navigationIndex = 1;
    } else {
      this.navigationIndex = 2;
    }
  },
};
</script>
<style scoped>
.settings-navigation {
  display: flex;
  flex-direction: column;
  width: 110px;
}
.navigation {
  height: 25px;
  background: #fff;
  border-radius: 1.25px;
  font-size: 10px;
  display: flex;
  align-items: center;
}
.navigation img {
  width: 15px;
  height: 15px;
  margin-left: 8.75px;
}
.navigation div {
  margin-left: 5px;
}
.navigation-active {
  background: #e9effd;
  color: #2e67ea;
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/settingsNavigation.vue